import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DefaultValuesService } from '../../services/defaultvalues.service';
import { ComponentTool } from '../../interfaces/componenttool';
import { Subject, takeUntil } from 'rxjs';
import { LandingPageGridComponent } from '../shared/landing-page-grid/landing-page-grid.component';

@Component({
    selector: 'app-mersy-landing',
    standalone: true,
    imports: [LandingPageGridComponent],
    templateUrl: './mersy-landing.component.html',
    styleUrls: ['./mersy-landing.component.less']
})
export class MersyLandingComponent implements OnInit, OnDestroy {
    items: any[] = [];
    clusterName: string = '';
    clusterIdentifier: string = '';
    componentToolEnum: typeof ComponentTool = ComponentTool;
    private readonly destroy$ = new Subject<void>();

    constructor(
        private route: ActivatedRoute,
        public defaults: DefaultValuesService
    ) {}

    ngOnInit(): void {
        this.route.data.pipe(takeUntil(this.destroy$)).subscribe(data => {
            this.clusterIdentifier = data['clusterContext'] || '';
            this.loadContent();
        });
        
    }

    loadContent() {
        if (this.clusterIdentifier) {
            const clusters = this.defaults.menuClusters || [];
            const cluster = clusters.find(c => this.isClusterMatch(c));

            if (cluster) {
                this.items = cluster.ClusterComponents || [];
                this.clusterName = cluster.DisplayName;
            } else {
                this.items = [];
                this.clusterName = '';
            }
        } else {
            this.items = this.defaults.menuClusters || [];
            this.clusterName = '';
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    private isClusterMatch(cluster: any): boolean {
        const clusterRoute = (cluster.Route || '').replace(/^\//, '').toLowerCase();
        const context = (this.clusterIdentifier || '').toLowerCase();
        return clusterRoute === context;
    }
}
